
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const ArrowCircleDownRight20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M12.85 12.86a.5.5 0 0 1-.35.14h-5a.5.5 0 0 1 0-1h3.8L7.14 7.85a.5.5 0 1 1 .7-.7L12 11.29V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.14.35ZM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
            fill="currentColor"
        />
    </svg>
}